<template>
  <div id="app">
    <section class="section-top hey">
      <div class="sv-container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/logo.svg')"
              alt="Saleshift Logo"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/logo.svg"
              alt="Saleshift Logo"
            />
            <h1 data-aos="fade-up">
              Grow your fitness brand with nutritional product sales
            </h1>
            <button
              type="button"
              class="sv-btn sv-btn--primary-white sv-btn--rounded"
              @click="isShown = true"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Shift Up
            </button>
          </div>
        </div>
      </div>
      <img
        v-if="isDev"
        class="section-top__mask-img"
        :src="require('./assets/images/masks/mask-header-bottom.svg')"
      />
      <img
        v-if="!isDev"
        class="section-top__mask-img"
        src="/saleshift/src/assets/images/masks/mask-header-bottom.svg"
      />
    </section>

    <div class="vp-combo sv-container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-6 col-xl-7">
          <section
            class="section-video"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="video-wrapper">
              <play-vimeo
                video-id="372741466"
                :is-autoplay-by-click="true"
              ></play-vimeo>
            </div>
          </section>
        </div>

        <div class="col-xl-4 offset-xl-1 vp-product-col">
          <section
            class="section-product-1"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-12 col-md-6 col-lg-12">
                  <div class="section-product-1__img"></div>
                </div>
                <div class="col-12 col-md-6 col-lg-12">
                  <p>
                    SaleShift™ is a supplement manufacturing and fulfilment
                    partner that helps fitness experts grow their revenues.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <section
      class="section-slider-pre"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
    >
      <div class="sv-container">
        <div class="row justify-content-center section-slider-pre__title">
          <div class="col-12 col-xl-8">
            <h2>
              Seamlessly integrate supplement sales into your existing fitness
              brand
            </h2>
          </div>
        </div>
        <div class="row section-slider-pre__content justify-content-lg-between">
          <div class="col-12 col-lg-6">
            <p>
              <span>W</span>e help fitness experts and influencers create
              immediate revenue streams by adding high-quality supplement sales
              into their existing sales flow. Our in-house team includes
              formulators, product designers, marketers, and developers that
              understand how to help fitness pros bring more value to their
              audience with top-tier sports nutrition and wellness products.
            </p>
          </div>

          <div class="col-12 col-lg-5">
            <p>
              We manufacture and fulfill product orders on your behalf so you
              can focus your time and energy on the things that matter most.
              Shift the way you think about product sales with SaleShift as your
              backend manufacturing and fulfillment partner.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section
      class="section-slider"
      :class="{ 'section-slider--background': slideIndex === 0 }"
    >
      <div class="container-fluid">
        <div class="section-slider-row">
          <div
            class="col-12 slider-number-labels-col"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          >
            <div class="slider-number-labels">
              <div class="slider-numbers">
                <div
                  class="slider-numbers__item"
                  :class="{ 'slider-numbers__item--active': slideIndex === 0 }"
                  @click="goToSlide(0)"
                >
                  <h5>01</h5>
                </div>
                <div
                  class="slider-numbers__item"
                  :class="{ 'slider-numbers__item--active': slideIndex === 1 }"
                  @click="goToSlide(1)"
                >
                  <h5>02</h5>
                </div>
                <div
                  class="slider-numbers__item"
                  :class="{ 'slider-numbers__item--active': slideIndex === 2 }"
                  @click="goToSlide(2)"
                >
                  <h5>03</h5>
                </div>
              </div>

              <div class="slider-labels">
                <div
                  class="slider-labels__item"
                  v-if="slideIndex === 0 || isDesktop"
                  @click="goToSlide(0)"
                  :class="{ 'slider-labels__item--active': slideIndex === 0 }"
                >
                  <h3>Select your products</h3>
                </div>
                <div
                  class="slider-labels__item"
                  v-if="slideIndex === 1 || isDesktop"
                  @click="goToSlide(1)"
                  :class="{ 'slider-labels__item--active': slideIndex === 1 }"
                >
                  <h3>Add to your website</h3>
                </div>
                <div
                  class="slider-labels__item"
                  v-if="slideIndex === 2 || isDesktop"
                  @click="goToSlide(2)"
                  :class="{ 'slider-labels__item--active': slideIndex === 2 }"
                >
                  <h3>Grow your brand</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="slider-col">
            <general-slider
              @change="setIndex($event)"
              :start-index="slideIndex"
              ref="slider"
            >
              <!-- v-if="isMobile || isTablet" -->
              <div class="slider__item slider__item--1"></div>
              <div class="slider__item slider__item--2"></div>
              <div class="slider__item slider__item--3"></div>
            </general-slider>
          </div>
        </div>
      </div>
    </section>

    <section class="section-benefits">
      <div class="sv-container">
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-1 benefits-item"
            data-aos="fade-up"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-1.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-1.svg"
            />
            <h3>Zero Cost</h3>
            <p>
              We shift the enormous responsibility and capital investment of
              starting supplement sales from your team to ours, giving you the
              freedom to build the brand you’ve always wanted.
            </p>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-2 benefits-item"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-2.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-2.svg"
            />
            <h3>Fulfillment</h3>
            <p>
              Our warehouse fulfillment center prides itself on speed and
              accuracy when fulfilling your customer’s orders.
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-1 benefits-item"
            data-aos="fade-up"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-3.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-3.svg"
            />
            <h3>No Contracts</h3>
            <p>
              With SaleShift you’re not bound to long-term contracts or required
              to post content. Your brand, your choice.
            </p>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-2 benefits-item"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-4.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-4.svg"
            />
            <h3>Customer Service</h3>
            <p>
              Our experienced, customer-focused call center will handle all
              product and order-related questions and service requests on your
              behalf.
            </p>
          </div>
        </div>

        <div class="row justify-content-center">
          <div
            class="col-12 col-md-9 col-lg-6 benefits-item benefits-item--pills"
            data-aos="fade-up"
          >
            <div>
              <img
                v-if="isDev"
                class="benefits-item-pills-mask benefits-item-pills-mask--top"
                :src="require('./assets/images/masks/video-mask-top.svg')"
              />
              <img
                v-if="!isDev"
                class="benefits-item-pills-mask benefits-item-pills-mask--top"
                src="/saleshift/src/assets/images/masks/video-mask-top.svg"
              />
              <img
                v-if="isDev"
                class="benefits-item-pills-mask benefits-item-pills-mask--bottom"
                :src="require('./assets/images/masks/video-mask-bottom.svg')"
              />
              <img
                v-if="!isDev"
                class="benefits-item-pills-mask benefits-item-pills-mask--bottom"
                src="/saleshift/src/assets/images/masks/video-mask-bottom.svg"
              />
            </div>
          </div>
          <div
            class="col-12 col-md-9 col-lg-4 offset-lg-1 benefits-item benefits-item--molecule"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/molecule.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/molecule.svg"
            />
            <p>
              We'll formulate and fulfill products on your behalf so you have
              the freedom to focus on what you do best.
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-1 benefits-item benefits-item--post-pills"
            data-aos="fade-up"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-5.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-5.svg"
            />
            <h3>Manufacturing</h3>
            <p>
              All of our manufacturing facilities are FDA approved and go above
              and beyond to deliver products of the highest caliber with
              globally-recognized GMP and NSF certifications.
            </p>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-2 benefits-item benefits-item--post-pills"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-6.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-6.svg"
            />
            <h3>Tech Platform & Analytics</h3>
            <p>
              Our completely customized platform allows you to instantly embed
              your favorite products directly on your website with the added
              benefit of 24/7 sales and activity monitoring.
            </p>
          </div>
        </div>
      </div>

      <div class="benefits-device-wrapper">
        <img
          v-if="isDev"
          :src="require('./assets/images/masks/bigger-mask-top.svg')"
          class="benefits-device-mask benefits-device-mask--top"
        />
        <img
          v-if="!isDev"
          src="/saleshift/src/assets/images/masks/bigger-mask-top.svg"
          class="benefits-device-mask benefits-device-mask--top"
        />
        <img
          v-if="isDev"
          :src="require('./assets/images/masks/bigger-mask-bottom.svg')"
          class="benefits-device-mask benefits-device-mask--bottom"
        />
        <img
          v-if="!isDev"
          src="/saleshift/src/assets/images/masks/bigger-mask-bottom.svg"
          class="benefits-device-mask benefits-device-mask--bottom"
        />
        <div class="benefits-device-row">
          <div class="sv-container">
            <div class="benefits-item benefits-item--device">
              <p data-aos="fade-up">
                It's time to grow your own fitness brand instead of someone
                else’s, because let’s face it— promo codes suck.
              </p>

              <div
                class="benefits-phone-image-wrapper"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <img
                  v-if="isDev"
                  :src="require('./assets/images/phone.png')"
                  class="d-md-none"
                />
                <img
                  v-if="!isDev"
                  src="/saleshift/src/assets/images/phone.png"
                  class="d-md-none"
                />
                <img
                  v-if="isDev"
                  :src="require('./assets/images/scrn-pymnts2.png')"
                  class="d-none d-md-inline"
                />
                <img
                  v-if="!isDev"
                  src="/saleshift/src/assets/images/scrn-pymnts2.png"
                  class="d-none d-md-inline"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sv-container">
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-1 benefits-item benefits-item--post-device"
            data-aos="fade-up"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-7.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-7.svg"
            />
            <h3>Bundle with eBooks and Digital Products</h3>
            <p>
              Take your ebook sales to the next level when you bundle them with
              relevant, complementary nutritional products.
            </p>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 offset-lg-2 benefits-item benefits-item--post-device"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/benefit-8.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/benefit-8.svg"
            />
            <h3>Custom Formulations</h3>
            <p>
              Our expert team of dietitians and supplement formulators can work
              with you to design unique, high-quality products that meet the
              specific needs of your fitness audience.
            </p>
          </div>
        </div>

        <div
          class="row justify-content-center align-items-center benefits__footer"
          data-aos="fade-up"
        >
          <div class="col-12 d-none d-md-block text-center">
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/graph.svg')"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/graph.svg"
            />
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 col-offset-lg-1 order-md-2 benefits__footer-image-col"
          >
            <div class="benefits__footer-image"></div>
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/graph-thick.svg')"
              class="d-md-none"
            />
            <img
              v-if="!isDev"
              src="/saleshift/src/assets/images/icons/graph-thick.svg"
              class="d-md-none"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-5 col-offset-lg-1 order-md-1">
            <p>
              Help your clients maximize their results with products
              specifically designed for fitness trainers and nutrition experts.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-stats-icons">
      <img
        v-if="isDev"
        class="section-stats-icons__mask"
        :src="require('./assets/images/masks/mask-towards-footer-top.svg')"
      />
      <img
        v-if="!isDev"
        class="section-stats-icons__mask"
        src="/saleshift/src/assets/images/masks/mask-towards-footer-top.svg"
      />
      <div>
        <div class="sv-container">
          <div class="section-stats-row">
            <div
              class="section-stats__stat"
              data-aos="fade-up"
              data-aos-id="startCountUp1"
            >
              <h3 v-if="startCountUp1">
                <animated-number :value="20" :duration="1500" :round="1" />+
              </h3>
              <h4>
                Years Of
                <br />Experience
              </h4>
            </div>
            <div
              class="section-stats__stat"
              data-aos="fade-up"
              data-aos-id="startCountUp2"
              data-aos-delay="500"
            >
              <h3 v-if="startCountUp2">
                <animated-number :value="100" :duration="2000" :round="1" />+
              </h3>
              <h4>
                Products
                <br />Formulating
              </h4>
            </div>
          </div>

          <div class="section-stats-icons__icons">
            <div data-aos="fade-up">
              <img
                v-if="isDev"
                :src="require('./assets/images/icons/fda.svg')"
              />
              <img
                v-if="!isDev"
                src="/saleshift/src/assets/images/icons/fda.svg"
              />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
              <img
                v-if="isDev"
                :src="require('./assets/images/icons/gmp.svg')"
              />
              <img
                v-if="!isDev"
                src="/saleshift/src/assets/images/icons/gmp.svg"
              />
            </div>
            <div data-aos="fade-up" data-aos-delay="200">
              <img
                v-if="isDev"
                :src="require('./assets/images/icons/usa.svg')"
              />
              <img
                v-if="!isDev"
                src="/saleshift/src/assets/images/icons/usa.svg"
              />
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
              <img
                v-if="isDev"
                :src="require('./assets/images/icons/nsf.svg')"
              />
              <img
                v-if="!isDev"
                src="/saleshift/src/assets/images/icons/nsf.svg"
              />
            </div>
            <div data-aos="fade-up" data-aos-delay="400">
              <img
                v-if="isDev"
                :src="require('./assets/images/icons/sqf.svg')"
              />
              <img
                v-if="!isDev"
                src="/saleshift/src/assets/images/icons/sqf.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer>
      <img
        v-if="isDev"
        class="footer__mask"
        :src="require('./assets/images/masks/mask-towards-footer-bottom.svg')"
      />
      <img
        v-if="!isDev"
        class="footer__mask"
        src="/saleshift/src/assets/images/masks/mask-towards-footer-bottom.svg"
      />
      <div class="sv-container">
        <h3 data-aos="fade-up">
          Ready to generate more
          <br class="d-none d-md-inline" />revenue for your business?
        </h3>
        <button
          type="button"
          class="sv-btn sv-btn--primary-white sv-btn--rounded"
          @click="isShown = true"
          data-aos="fade-up"
        >
          Shift Up & Grow
        </button>

        <!-- <p class="footer__content">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent
          tincidunt mauris a ligula luctus, in dapibus dui vulputate. Phasellus et
          metus nibh. Sed condimentum interdum nibh, sit amet pellentesque orci
          pellentesque quis.
        </p>-->

        <!-- <p class="footer__logo">
          Powered by
          <img v-if="isDev"
          :src="require('./assets/images/icons/snap.svg')" />Snap® Supplements
        </p>-->

        <p class="footer__rights">
          2019–2020 © SaleShift, Inc.
          <br class="d-md-none" />All rights reserved.
        </p>
      </div>
    </footer>

    <modal
      class="sign-up-modal"
      :is-shown="isShown"
      @closeModal="isShown = false"
      v-cloak
    >
      <div slot="body">
        <div class="sign-up-modal__form" v-if="!formSuccess">
          <h3>
            Shift up and grow
            <br />your bottom line
          </h3>
          <form @submit.prevent="handleSubmit">
            <input
              type="text"
              v-model="formData.name"
              placeholder="Your Name"
              required
            />
            <input
              type="email"
              v-model="formData.email"
              placeholder="Email Address"
              required
            />
            <input
              type="text"
              v-model="formData.phone"
              v-mask="'(###) ###-####'"
              placeholder="Phone Number (optional)"
            />
            <textarea
              type="text"
              v-model="formData.about"
              placeholder="Tell us about yourself"
              required
            />
            <button
              type="submit"
              class="sv-btn sv-btn--primary sv-btn--rounded"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">Sign Up</span>
              <loader v-else></loader>
            </button>
          </form>
        </div>
        <div class="sign-up-modal__success" v-else>
          <div>
            <img
              v-if="isDev"
              :src="require('./assets/images/icons/icon-check.svg')"
            />
          </div>
          <h5>Thank you for your interest!</h5>
          <h5>We will be in contact with you shortly.</h5>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import PlayVimeo from "./components/PlayVimeo.vue";
import GeneralSlider from "./components/GeneralSlider.vue";
import Loader from "./components/Loader.vue";
import Modal from "./components/Modal.vue";
import axios from "axios";
import { mask } from "vue-the-mask";
import AOS from "aos";
import "aos/dist/aos.css";
import AnimatedNumber from "animated-number-vue";

export default {
  name: "App",
  components: {
    Modal,
    GeneralSlider,
    PlayVimeo,
    Loader,
    AnimatedNumber
  },
  directives: {
    mask
  },
  data() {
    return {
      isLoading: false,
      isMobile: "",
      isTablet: "",
      isDesktop: "",
      isShown: false,
      slideIndex: 0,
      formData: {
        name: "",
        email: "",
        phone: "",
        about: "",
        c: ""
      },
      formSuccess: false,
      startCountUp1: false,
      startCountUp2: false
    };
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV === "development";
    }
  },
  created() {
    AOS.init({
      // once: true
      duration: 800,
      // anchorPlacement: "center-bottom"
      anchorPlacement: "top-bottom"
    });

    document.addEventListener("aos:in", ({ detail }) => {
      if (detail.dataset.aosId === "startCountUp1") {
        this.startCountUp1 = true;
      }
      if (detail.dataset.aosId === "startCountUp2") {
        this.startCountUp2 = true;
      }
    });
    document.addEventListener("aos:out", ({ detail }) => {
      if (detail.dataset.aosId === "startCountUp1") {
        this.startCountUp1 = false;
      }
      if (detail.dataset.aosId === "startCountUp2") {
        this.startCountUp2 = false;
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.c = this.getURLParameter("c") || "";

      const mqMobile = window.matchMedia("(max-width: 767px)");
      const mqTablet = window.matchMedia(
        "(min-width:768px) and (max-width: 1023px)"
      );
      const mqDesktop = window.matchMedia("(min-width: 1024px)");

      mqMobile.addListener(this.screenTestMobile);
      mqTablet.addListener(this.screenTestTablet);
      mqDesktop.addListener(this.screenTestDesktop);

      this.screenTestMobile(mqMobile);
      this.screenTestTablet(mqTablet);
      this.screenTestDesktop(mqDesktop);
    });
  },
  watch: {
    isMobile() {
      this.$nextTick(() => {
        AOS.refresh();
      });
    },
    isTablet() {
      this.$nextTick(() => {
        AOS.refresh();
      });
    },
    isDesktop() {
      this.$nextTick(() => {
        AOS.refresh();
      });
    }
  },
  methods: {
    getURLParameter(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.search
          ) || [null, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    handleSubmit() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      axios
        .post("/api/snap/influencer/saleshift_apply", this.formData)
        .then(res => {
          if (res.status >= 200 && res.status < 300) {
            this.isLoading = false;
            this.formSuccess = true;
          } else {
            console.error("API Submit Error!", res);
          }
        })
        .catch(error => {
          console.error("API Submit Error!", error);
        });
    },
    goToSlide(index) {
      if (this.$refs.slider) {
        this.$refs.slider.$refs.flickity.select(index);
        this.$refs.slider.$refs.flickity.pausePlayer();
        setTimeout(() => {
          this.$refs.slider.$refs.flickity.unpausePlayer();
        }, 3000);
      } else {
        this.slideIndex = index;
      }
    },
    setIndex(index) {
      this.slideIndex = index;
    },
    screenTestMobile: function(e) {
      this.isMobile = e.matches;
    },
    screenTestTablet: function(e) {
      this.isTablet = e.matches;
    },
    screenTestDesktop: function(e) {
      this.isDesktop = e.matches;
    }
  }
};
</script>

<style lang="scss">
@import "./assets/sass/_variables.scss";
@import "./assets/sass/_mixins.scss";

.section-top {
  text-align: center;
  background-size: cover;
  background-position: 50% 0%;
  background-image: url("./assets/images/header.jpg");
  padding-top: 24px;
  padding-bottom: 130px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    background-color: rgba(black, 0.2);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .section-top__mask-img {
    position: absolute;
    width: calc(100% + 1px);
    bottom: -1px;
    left: -1px;
    pointer-events: none;
  }
  @media (min-width: $screen-md-min) {
    padding-top: 48px;
    padding-bottom: 135px;
  }
  @media (min-width: $screen-lg-min) {
    padding-bottom: 336px;
  }
  .container {
    padding-right: 24px;
    padding-left: 24px;
    @media (min-width: $screen-md-min) {
      padding-right: 48px;
      padding-left: 48px;
    }
  }
  img {
    width: 109px;
    @media (min-width: $screen-md-min) {
      width: 123px;
    }
  }
  h1 {
    margin-top: 80px - 5;
    text-transform: uppercase;
    color: $sv-white;
    @media (min-width: $screen-md-min) {
      margin-top: 120px - 5;
    }
    @media (min-width: $screen-lg-min) {
      margin-top: 160px - 5;
    }
  }
  button {
    margin-top: 36px;
    cursor: pointer;
    @media (min-width: $screen-md-min) {
      margin-top: 48px;
    }
  }
}

.vp-product-col {
  @media (min-width: $screen-lg-min) {
    margin-left: percentage(1/24);
    flex: 0 0 percentage(9/24);
    max-width: percentage(9/24);
  }
}

.section-video {
  .video-wrapper {
    max-width: 655px;
    margin-left: auto;
    margin-right: auto;
    background-size: contain;
    background-position: center;
    // background: $sv-gray3;
    background-image: url("./assets/images/video-thumbnail.png");
    position: relative;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    margin-top: -130px + 48;
    @media (min-width: $screen-sm-min) {
      margin-top: -130px + 24;
    }
    @media (min-width: $screen-md-min) {
      margin-top: -135px;
    }
    @media (min-width: $screen-lg-min) {
      margin-top: -336px + 88;
    }
    @media (min-width: $screen-lg-min) {
      max-width: 655px;
    }
    &::before {
      display: block;
      content: "";
      padding-bottom: percentage(1150/1490);
    }
    .sv-btn {
      font-size: 0;
      line-height: 0;
      min-width: 1px;
      height: auto;
      padding: 50px;
      margin: 0;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      > svg {
        top: 0;
        transform: none;
        margin: 0;
        width: 48px;
        height: 48px;
        @media (min-width: $screen-md-min) {
          width: 64px;
          height: 64px;
        }
      }
    }
  }
}

.section-product-1 {
  @media (min-width: $screen-md-min) {
    margin-top: 24px;
  }
  @media (min-width: $screen-lg-min) {
    margin-top: -320px;
  }
  @media (min-width: $screen-xl-min) {
    margin-top: -370px;
  }
  .container-fluid {
    padding-right: 24px;
    padding-left: 24px;
    @media (min-width: $screen-md-min) {
      padding-right: 48px;
      padding-left: 48px;
    }
    @media (min-width: $screen-lg-min) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  p {
    margin-top: 24px;
    @include font-medium-italic;
    @media (min-width: $screen-md-min) {
      margin-top: 0;
      text-align: left;
      font-size: 24px;
      line-height: 32px;
    }
    @media (min-width: $screen-lg-min) {
      margin-top: 48px;
    }
  }
}

.section-slider-pre {
  margin-top: 80px;
  @media (min-width: $screen-md-min) {
    margin-top: 70px;
  }
  @media (min-width: $screen-lg-min) {
    margin-top: 120px;
  }
  h2 {
    text-transform: uppercase;
  }

  p {
    text-align: left;
    @media (min-width: $screen-md-min) {
      font-size: 24px;
      line-height: 32px;
    }
    span {
      font-size: 48px;
      line-height: 48px;
      width: 48px;
      @include font-condensed-regular;
      float: left;
      text-align: center;
      @media (min-width: $screen-md-min) {
        font-size: 64px;
        line-height: 64px;
        width: 64px;
      }
    }
  }
}

.section-slider-pre__content {
  margin-top: 48px;
  @media (min-width: $screen-md-min) {
    margin-top: 70px;
  }
  > div + div {
    margin-top: 24px;
    @media (min-width: $screen-lg-min) {
      margin-top: 0;
    }
  }
  > div:nth-child(2) {
    @media (min-width: $screen-lg-min) {
      padding-right: 40px + 10;
    }
  }
}

.section-product-1__img {
  text-align: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("./assets/images/cardio.png");
  width: 200px;
  margin: 0 auto;
  max-width: 100%;
  @media (min-width: $screen-md-min) {
    width: 100%;
    max-width: 364px;
  }
  &::before {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
}

.section-slider {
  margin-top: 80px;
  overflow: hidden;
  position: relative;
  @media (min-width: $screen-md-min) {
    margin-top: 120px;
  }
  > .container-fluid {
    overflow: visible;
    @media (min-width: $screen-lg-min) {
      max-width: 984px;
    }
    @media (min-width: $screen-xl-min) {
      max-width: 1160px;
    }
  }
  .slider-number-labels-col {
    @media (min-width: $screen-lg-min) {
      flex: 0 0 461px + 20;
      max-width: 461px + 20;
    }
  }
  .slider-col {
    @media (min-width: $screen-lg-min) {
      padding: 0 10px;
      flex: 0 0 946px + 20;
      max-width: 946px + 20;
    }
  }
  &::before {
    @media (min-width: $screen-lg-min) {
      left: 100%;
      top: 0;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 100% 50%;
      background-image: url("./assets/images/bottle-group-desktop.jpg");
      transition: left 0.5s;
    }
  }
}

.section-slider--background {
  &::before {
    @media (min-width: $screen-lg-min) {
      left: 0;
    }
  }
}

.section-slider--1 {
  @media (min-width: $screen-lg-min) {
  }
}

.section-slider-row {
  @media (min-width: $screen-lg-min) {
    display: flex;
    flex-wrap: no-wrap;
    align-items: center;
    margin: 0 -10px;
  }
}

.slider-number-labels {
  @media (min-width: $screen-lg-min) {
    display: flex;
    margin: 0 -16.5px;
  }
}

.slider-numbers {
  display: flex;
  justify-content: space-between;
  width: 240px;
  margin: 0 auto;
  @media (min-width: $screen-md-min) {
    width: 350px;
  }
  @media (min-width: $screen-lg-min) {
    flex-direction: column;
    padding: 0 16.5px;
    flex: 0 0 64px + 33;
    margin: 0;
  }
}

.slider-numbers__item {
  width: 48px;
  height: 48px;
  display: flex;
  border: 1px solid $sv-gray2;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (min-width: $screen-md-min) {
    width: 64px;
    height: 64px;
  }
  h5 {
    @include font-medium-italic;
    color: $sv-gray3;
  }
}
.slider-numbers__item--active {
  border: 3px solid black;
  h5 {
    color: black;
  }
}

.slider-labels__item {
  margin-top: 24px;
  text-transform: none;
  z-index: 1;
  position: relative;
  @media (min-width: $screen-md-min) {
    margin-top: 48px;
  }
  @media (min-width: $screen-lg-min) {
    cursor: pointer;
    text-align: left;
    height: 64px;
    padding: 0 16.5px;
    display: flex;
    align-items: center;
    margin-top: 0;
  }

  h3 {
    text-transform: none;
    @media (min-width: $screen-lg-min) {
      font-size: 36px;
    }
  }
}

.slider-labels__item + .slider-labels__item {
  @media (min-width: $screen-lg-min) {
    margin-top: 80px;
  }
}

.slider-labels__item--active {
  h3 {
    @media (min-width: $screen-lg-min) {
      font-size: 48px;
    }
  }
}

.slider-col {
  margin: 24px -10px 0;
  @media (min-width: $screen-md-min) {
    margin-top: 0;
  }
}

.slider__item {
  width: 100%;
  height: 471px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  @media (min-width: $screen-md-min) {
    height: 628px;
  }
}

.slider__item--1 {
  background-size: cover;
  background-image: url("./assets/images/bottle-group.jpg");
  background-position: 50% 0%;
  @media (min-width: $screen-lg-min) {
    background-image: none;
  }
}

.slider__item--2 {
  background-image: url("./assets/images/mobile-step-2-grouped.png");

  @media (min-width: $screen-md-min) {
    background-image: url("./assets/images/slide-2.png");
    background-size: auto 100%;
  }
}
.slider__item--3 {
  background-image: url("./assets/images/mobile-step-3-grouped.png");
  @media (min-width: $screen-md-min) {
    background-image: url("./assets/images/slide-3.png");
    background-size: auto 100%;
  }
}

.section-benefits {
  margin-top: 80px;
  @media (min-width: $screen-md-min) {
    margin-top: 55px;
  }
  @media (min-width: $screen-lg-min) {
    margin-top: 120px;
  }
  .container {
    padding: 0 24px;
    @media (min-width: $screen-md-min) {
      padding: 0 48px;
    }
  }
  > div:first-child {
    > .row:first-child {
      > div:first-child {
        margin-top: 0;
      }
      > div:nth-child(2) {
        @media (min-width: $screen-md-min) {
          margin-top: 0;
        }
      }
    }
  }
}

.benefits-item {
  margin-top: 80px;
  @media (min-width: $screen-md-min) {
    text-align: left;
  }
  @media (min-width: $screen-lg-min) {
    margin-top: 96px;
  }
  img {
    width: 80px;
    @media (min-width: $screen-md-min) {
      width: 100px;
    }
  }
  h3 {
    margin-top: 16px - 5;
    text-transform: none;
    @media (min-width: $screen-md-min) {
      margin-top: 24px - 1;
    }
  }
  p {
    margin-top: 16px;
    @media (min-width: $screen-md-min) {
      margin-top: 24px;
      font-size: 24px;
      line-height: 32px;
    }
  }
}

.benefits-item--pills {
  @media (min-width: $screen-lg-min) {
    margin-top: 220px;
  }
  > div {
    width: 100%;
    background-size: cover;
    background-position: center;
    background-image: url("./assets/images/pills.jpg");
    margin: 0 auto;
    position: relative;
    &::before {
      content: "";
      display: block;
      padding-bottom: percentage(212/272);
      @media (min-width: $screen-md-min) {
        padding-bottom: percentage(386/498);
      }
    }
  }
  .benefits-item-pills-mask {
    pointer-events: none;
    position: absolute;
    width: 100%;
    left: 0;
  }
  .benefits-item-pills-mask--top {
    top: 0;
  }
  .benefits-item-pills-mask--bottom {
    bottom: 0;
  }
}

.benefits-item--molecule {
  margin-top: 24px;
  text-align: center;
  @media (min-width: $screen-lg-min) {
    margin-top: 220px;
    text-align: left;
  }
  img {
    max-width: 100%;
    width: 200px;
    @media (min-width: $screen-lg-min) {
      width: percentage(256/364);
      max-width: 256px;
    }
  }
  p {
    @include font-medium-italic;
    margin-top: 24px;
    @media (min-width: $screen-md-min) {
      font-size: 28px;
      line-height: 38px;
    }
  }
}

.benefits-item--post-pills {
  @media (min-width: $screen-lg-min) {
    margin-top: 176px;
  }
}

.benefits-item--post-device {
  @media (min-width: $screen-lg-min) {
    margin-top: 133px;
  }
}

.benefits-device-wrapper {
  padding: 1px 0;
  margin-top: 80px;
  overflow: hidden;
  position: relative;
}

.benefits-device-mask {
  pointer-events: none;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
}
.benefits-device-mask--top {
  top: 0;
}
.benefits-device-mask--bottom {
  bottom: 0;
}

.benefits-device-row {
  padding-top: 100px;
  background-color: $sv-gray1;
  @media (min-width: $screen-md-min) {
    padding-top: 110px;
  }
  @media (min-width: $screen-lg-min) {
    padding-top: 214px;
  }
}

.benefits-item--device {
  text-align: center;
  margin-top: 0;
  overflow: hidden;
  p {
    margin: 0 auto;
    @include font-medium-italic;
    @media (min-width: $screen-md-min) {
      font-size: 28px;
      line-height: 36px;
      width: percentage(6/8);
    }
    @media (min-width: $screen-lg-min) {
      width: percentage(8/12);
    }
  }
}

.benefits-phone-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  bottom: -105px;
  margin-top: 48px - 105;
  @media (min-width: $screen-md-min) {
    bottom: -53px;
    margin-top: 80px - 53;
  }
  img {
    height: auto;
    width: 240px + 30;
    @media (min-width: $screen-md-min) {
      width: 672px + 30;
    }
    @media (min-width: $screen-lg-min) {
      width: 946px + 30;
    }
  }
}

.benefits__footer {
  margin-top: 80px;
  @media (min-width: $screen-lg-min) {
    margin-top: 160px;
  }
  img {
    width: 228px;
    margin-top: -25px;
    @media (min-width: $screen-md-min) {
      width: percentage(6/8);
      margin: 0;
    }
    @media (min-width: $screen-lg-min) {
      width: percentage(5/12);
    }
  }
  p {
    margin-top: 24px;
    @include font-medium-italic;
    font-size: 18px;
    line-height: 24px;
    @media (min-width: $screen-md-min) {
      text-align: left;
      font-size: 26px;
      line-height: 36px;
      margin-top: 0;
    }
    @media (min-width: $screen-lg-min) {
      font-size: 28px;
    }
  }
}

.benefits__footer-image-col {
  @media (min-width: $screen-lg-min) {
    margin-top: -95px;
    z-index: -1;
  }
}

.benefits__footer-image {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("./assets/images/total-body.jpg");
  margin: 0 auto;
  width: 200px;
  @media (min-width: $screen-md-min) {
    width: 100%;
  }
  &::before {
    content: "";
    display: block;
    padding-bottom: percentage(154/200);
  }
}

.section-stats-icons {
  position: relative;
  margin-top: 80px;
  color: $sv-white;
  > div {
    margin-top: -5px;
    background-color: black;
    padding: 60px 0;
    @media (min-width: $screen-lg-min) {
      padding: 90px 0;
    }
  }
}

.section-stats-icons__mask {
  width: 100%;
  pointer-events: none;
  position: relative;
  top: 1px;
}

.section-stats-row {
  @media (min-width: $screen-lg-min) {
    display: flex;
    width: 100%;
    max-width: 981px;
    justify-content: space-between;
    margin: 0 auto;
  }
}

.section-stats__stat {
  @media (min-width: $screen-md-min) {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
  }
  h3 {
    @include font-condensed-medium-italic;
    font-size: 80px;
    line-height: 80px;
    @media (min-width: $screen-md-min) {
      padding-left: 10px;
      padding-right: 10px;
      font-size: 120px;
      line-height: 120px;
    }
  }
  h4 {
    margin-top: 16px;
    text-transform: uppercase;
    @include font-condensed-bold-italic;
    @media (min-width: $screen-md-min) {
      padding-left: 10px;
      padding-right: 10px;
      font-size: 48px;
      line-height: 48px;
    }
  }
}

.section-stats__stat + .section-stats__stat {
  margin-top: 48px;
  @media (min-width: $screen-lg-min) {
    margin-top: 0;
  }
}

.section-stats-icons__icons {
  margin: 80px -17.5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: $screen-md-min) {
    margin: 80px -24px 0;
  }
  @media (min-width: $screen-lg-min) {
    margin: 80px -23px 0;
  }
  div {
    padding-left: 17.5px;
    padding-right: 17.5px;
    @media (min-width: $screen-md-min) {
      padding-left: 24px;
      padding-right: 24px;
    }
    @media (min-width: $screen-lg-min) {
      padding-left: 23px;
      padding-right: 23px;
    }
  }
  img {
    width: 58px;
    @media (min-width: $screen-md-min) {
      width: 80px;
    }
  }
}

footer {
  background-size: cover;
  background-position: 73% 0%;
  background-image: url("./assets/images/footer.jpg");
  color: $sv-white;
  position: relative;
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    background-color: rgba(black, 0.2);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  > div {
    padding-top: 110px;
    padding-bottom: 48px;
    @media (min-width: $screen-md-min) {
      padding-top: 96px;
    }
    @media (min-width: $screen-lg-min) {
      padding-top: 158px;
    }
  }
  h3 {
    text-transform: uppercase;
  }
  .sv-btn {
    margin-top: 48px;
    min-width: 240px;
    cursor: pointer;
  }
}
.footer__mask {
  position: relative;
  top: -1px;
  width: 100%;
  pointer-events: none;
}

// .footer__content {
//   margin-top: 48px;
//   font-size: 14px;
//   line-height: 20px;
//   @media (min-width: $screen-md-min) {
//     margin-top: 80px;
//     font-size: 16px;
//     line-height: 24px;
//   }
// }

// .footer__logo {
//   margin-top: 48px + 120;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   @include font-condensed-medium-italic;
//   font-size: 16px;
//   line-height: 24px;
//   @media (min-width: $screen-md-min) {
//     font-size: 18px;
//     margin-top: 80px + 72;
//   }
//   @media (min-width: $screen-lg-min) {
//     margin-top: 146px + 48;
//   }
//   img {
//     width: 64px;
//     margin: 0 8px;
//     @media (min-width: $screen-md-min) {
//       margin: 0 16px;
//     }
//   }
// }

.footer__rights {
  // margin-top: 24px;
  margin-top: 24px + 48 + 120 + 24; // for removed lines in design
  font-size: 14px;
  line-height: 20px;
  @media (min-width: $screen-md-min) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 24px + 80 + 72 + 24;
  }
  @media (min-width: $screen-lg-min) {
    margin-top: 24px + 146 + 48 + 24;
  }
}

.sign-up-modal {
  .modal-body {
    margin: 0;
  }
  .modal-container {
    max-width: 100%;
    width: 484px;
    height: auto;
    padding: 48px 24px;
    @media (min-width: $screen-md-min) {
      padding: 80px;
    }
  }
  .modal-close-button {
    top: -48px + 10;
    right: -24px + 10;
    @media (min-width: $screen-md-min) {
      top: -80px + 10;
      right: -80px + 10;
    }
  }
  h3 {
    text-transform: uppercase;
    font-size: 36px;
    line-height: 36px;
  }
  form {
    margin-top: 48px;
    button {
      cursor: pointer;
      text-transform: uppercase;
      margin-top: 48px;
    }
  }
  input {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    height: 56px;
    border: 0;
    border-bottom: 1px solid $sv-gray2;
    &:focus {
      outline: 0;
      border-color: black;
      border-width: 2px;
    }
  }
  input + input {
    margin-top: 24px;
  }

  input + textarea {
    margin-top: 24px * 1.5;
  }
  textarea {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    height: 80px;
    border: 1px solid $sv-gray2;
    -webkit-appearance: none;
    appearance: none;
    &:focus {
      outline: 0;
      border-color: black;
      border-width: 2px;
    }
  }
}

.sign-up-modal__success {
  > div {
    border-radius: 50px;
    border: 2px solid $sv-primary;
    display: inline-flex;
    margin: 0 auto;
    padding: 8px;
    img {
      position: relative;
      width: 48px;
      left: 0px;
      top: 2px;
    }
  }
  h5 {
    margin-top: 24px;
  }
}
</style>
